import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66ce0bfc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.alignLeft ? 'q-my-sm q-mx-md' : 'flex-center q-ma-xl', "full-width column"])
  }, [
    (!_ctx.hideIcon && !_ctx.alignLeft)
      ? (_openBlock(), _createBlock(_component_q_icon, {
          key: 0,
          name: _ctx.icon,
          size: _ctx.props.icon,
          class: "q-mb-sm"
        }, null, 8, ["name", "size"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.alignLeft ? 'q-mx-md' : 'text-center')
    }, [
      _createElementVNode("div", _mergeProps(_ctx.props.message, { class: "text-message" }), _toDisplayString(_ctx.t(_ctx.message)), 17),
      _createElementVNode("div", _mergeProps({
        class: ["q-px-lg text-hint handle-break-line", { 'q-mt-md': !!_ctx.message }]
      }, _ctx.props.hint, {
        innerHTML: _ctx.t(_ctx.hint)
      }), null, 16, _hoisted_1)
    ], 2),
    _renderSlot(_ctx.$slots, "create", {}, undefined, true)
  ], 2))
}